<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>CAMPUS LIFE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Hostel Infrastructure</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="section-heading text-start mb-0 text-center">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Our Academic Blocks</h2>
        <p>Spelled over 120 acres, ARNI University’s campus is the perfect combination of modern infrastructure and
            eye-catching beautiful natural beauty. Moreover, the lush-green breathtaking Dhauladhar Mountain Ranges
            works as the ornaments of the place. The overall natural scene creates inspiring surroundings that foster
            creativity, innovation, and peace to harness growth and productivity. The Campus is equipped with all
            amenities to offer an exceptional learning experience.
        </p>
        <p>The University has an extremely well designed infrastructure of approx eight Academic Blocks and very well
            equipped with state-of-the-art Laboratories, to inspire students to learn their lessons in a very congenial
            environment. The class rooms have all modern learning aids/ comforts to activate all senses of the students
            and make them learning savvy. The class rooms and Seminar Halls are also equipped with the latest teaching
            aids and presentation tools.</p>
        <p>Whether you’re studying, researching, or simply unwinding, ARNI University offers a “home away from home”
            that ensures comfort, convenience, and growth.
        </p>

        <h2 class="text-center">Hub of Knowledge</h2>
        <p>Following the motivation of educational excellence, our academic blocks are designed with a focus on
            functionality. It is not just a building; it is a center of activity, collaborative learning, intellectual
            curiosity, and academic growth.
        </p>
        <p>The Hostel caution money and room rent are payable on allotment of the room in advance for the whole
            Semester, along with the Tuition fee, as per the rules approved by the Govt of HP. Admission to the Hostel
            cannot be withdrawn before one academic year.
        </p>
        <ul>
            <li>The Hostel caution money and room rent are payable on allotment of the room in advance for the whole
                Semester, along with the Tuition fee, as per the rules approved by the Govt of HP. The admission in the
                Hostel cannot be withdrawn before one academic year. WI – FI CAMPUS
            </li>
        </ul>
        <div class="row">
            <div class="col-lg-4 col-lg-4 col-sm-12 mt-5">
                <img src="assets/img/hostel/block1.jpg" class="cover-background w-100 h-100"/>
                <div class="section-heading text-start mb-0 text-center">
                    <span class=" sub-title">Block-A</span>
                </div>
            </div>

            <div class="col-lg-4 col-lg-4 col-sm-12 mt-5">
                <img src="assets/img/hostel/block2.jpg" class="cover-background w-100 h-100"/>
                <div class="section-heading text-start mb-0 text-center">
                    <span class=" sub-title">Block-B</span>
                </div>
            </div>

            <div class="col-lg-4 col-lg-4 col-sm-12 mt-5">
                <img src="assets/img/hostel/block3.jpg" class="cover-background w-100 h-100"/>
                <div class="section-heading text-start mb-0 text-center">
                    <span class=" sub-title">Block-C</span>
                </div>
            </div>
            <div class="col-lg-4 col-lg-4 col-sm-12 mt-5">
                <img src="assets/img/hostel/block4.jpg" class="cover-background w-100 h-100"/>
                <div class="section-heading text-start mb-0 text-center">
                    <span class=" sub-title">Block-D</span>
                </div>
            </div>
            <div class="col-lg-4 col-lg-4 col-sm-12 mt-5">
                <img src="assets/img/hostel/block5.jpg" class="cover-background w-100 h-100"/>
                <div class="section-heading text-start mb-0 text-center">
                    <span class=" sub-title">Block-E</span>
                </div>
            </div>
        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Library Facilities – Peaceful Place to Acquire Knowledge</h2>
        <p>Libraries are the hub of acquired knowledge for mind development. ARNI library offers an extensive collection
            of books of over 28000 different streams. The library is well-furnished with air conditioning that provides
            a comfortable, peaceful environment to the students. Moreover, the library is filled with a large number of
            journals, motivational books, and research papers related to management, technology, science, and arts.
        </p>
        <ul>
            <li>Seamless access to books, e-books, and research papers to keep updated with global academic trends.
            </li>
            <li> A dedicated study zone along with a comfortable chairs and desks appropriate for group studies or
                individual studies.
            </li>
            <li>Well-organized bookshelf along with professional guidance to get help for the most appropriate book.
            </li>
        </ul>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/lib1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/lib2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/lib3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/lib4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Mess Facilities – Good Food, Good Mind</h2>
        <p>At ARNI University, we value the importance of wholesome meals in fostering a productive academic journey.
            Our Mess facility is designed to provide well-nourished and nutritious food made with proper hygiene. The
            mess is not just to have food only; it is the place where students strengthen their bond over meals. The
            Mess charges are paid in advance for the whole Semester, at the beginning of each Semester along with other
            charges of the University.
        </p>
        <ul>
            <li>Well-curated menu offering seasoned vegetables, pulses, and fruits for the proper diet of the students.
            </li>
            <li>To maintain proper hygiene and taste, a dedicated team is assigned to look over the end-to-end process.
            </li>
            <li>The university has two separate large dining halls for the boys’ hostellers and girls’ hostellers,
                ensuring proper management and security.
            </li>
        </ul>
        <div class="row">
            <div class="col-lg-4 col-lg-4 col-sm-12">
                <img src="assets/img/hostel/mess1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-4 col-lg-4 col-sm-12">
                <img src="assets/img/hostel/mess2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-4 col-lg-4 col-sm-12">
                <img src="assets/img/hostel/mess3.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Sports Facilities – Encourage Fitness and Sports Spirit</h2>
        <p>Being one of the foremost educational institutes, we encourage extracurricular activities for the overall
            growth of our students, whether it's about academic or physical development. Thus, the campus provides
            sports facilities to all the students and has almost all the necessary assets for indoor or outdoor
            activities. The campus has a modern gym along with professional trainers. We believe in the vision of
            “Khelega India, Tabhi Toh Badhega India" We have a team of professional trainers and instructors for various
            sports that guide our upcoming athletes most appropriately. We have facilities for sports including:
        </p>
        <span class="blog-style1">
            <div class="row">
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Cricket</a>
            </div>
            <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Football</a>
            </div>
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Basketball</a>
            </div>
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Hockey</a>
            </div>
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Volleyball</a>
            </div>
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Lawn Tennis</a>
            </div>
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Table Tennis</a>
            </div>
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Badminton</a>
            </div>
                <div class="category-box col-lg-2 col-md-2 col-sm-12">
            <a href="#!">Kho – Kho</a>
            </div>
            </div>
        </span>
        <p>Our students participated in numerous State or intercollege competitions. Their courage and our support have
            brought trophies to the University several times and this will continue for many upcoming years.
        </p>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/sport1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/sport2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/sport3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/sport4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Cafeteria Facilities – Taste Meets and Greets Togetherness</h2>
        <p>Having a good time with friends while eating tasty food is such a rejuvenating experience after all-day-long
            physical and mental learning. We believe that a satisfied appetite and taste buds lead to a well-nourished
            mind. Our cafeteria is not just a place where the students eat; this is the place to refresh, connect, and
            unwind the thoughts and ideas.
        </p>
        <p>This is the place for meet, greet, and gossiping that empowers personal connections and togetherness along
            with delicious foods and beverages made with authenticity and proper hygiene.
        </p>
        <p>We have a list of diseases on our menu from healthy options such as milk, juice, and fruits to pizzas,
            shakes, chocolates, and many more.
        </p>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/21.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Hostel Facilities – Feel Like A Home When Away From Home</h2>
        <p>ARNI University takes pride in providing comfortable, secure, well-equipped, and well-maintained hostel
            facilities to our students that ensure feel like a home while manifesting their dreams. The rooms and
            ambiance of our hotel are designed to endeavor learning, growth, and relaxation.
        </p>
        <p>To ensure privacy, a friendly atmosphere, and security, we have a separate hostel building for boys and
            girls.
        </p>
        <p> Our hostel is spacious and well-furnished and offers rooms for single, double, or even triple occupancy that
            suit every student's preference.
        </p>
        <p>For the comfort of the students, our hostel offers hygienic delicious food, clean drinking water, electricity
            backup, and 24/7 CCTV surveillance. We care extra for safety and security, especially for the girls to serve
            the best they deserve.
        </p>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel4.jpg" class="cover-background w-100 h-100"/>
            </div>

        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">GYM Facilities – Empowering Wellness and Fitness</h2>
        <p>Following the concept of this ever-evolving modern ear, we understand the importance of physical wellness.
            With cutting-edge gym facilities, we provide students with a perfect environment to stay fit, energetic, and
            stress-free. Our goal is to lead a healthy life.
        </p>
        <p>We have a gender-specific workout area for boys and girls to ensure safe, secure, private, and comfortable
            surroundings.
        </p>
        <p>Our gym is equipped with the latest advanced fitness machines, free weights, cardio sections, etc.
        </p>
        <p>All the students are on a fitness journey under the supervision of national-fame instructors to avoid any
            mishaps.
        </p>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/gym1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/gym2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/gym3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/gym4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Transport Facilities – Safe, Reliable, and Convenient </h2>
        <p>We prioritize the safety, comfort, and convenience of the students and faculty to commute daily with our
            well-organized transport facilities. Whether you are attending your daily classes, participating in
            extracurricular activities, or returning home, ARNI transportation ensures a smooth journey along with your
            safety and security. The students who opt for transportation need to pay the full amount at the beginning of
            the whole semester. Charges one paid, cannot not returned or withdrawn.
        </p>
        <p> Pick and drop Facilities in our comfortable vehicle for students from the surrounding areas of Himachal
            Pradesh, Punjab, and Jammu & Kashmir.
        </p>
        <p>The vehicles are equipped with the necessary safety measures such as GPS tracking and First-aid kits</p>
        <p> Well-planned pickup facility allows students to concentrate on their studies rather than on commuting.
        </p>
        <h3>The areas connected are:</h3>
        <ul>
            <li>Talwara – Mukerian – Arni.</li>
            <li> Kathua – Pathankot- Arni.</li>
            <li>Bhadwar – Nurpur- Arni.</li>
            <li>Mehra Phatak-Gangath-Arni.</li>
            <li>Jawali- Indora- Arni.</li>
            <li>Dhameta-Rahan- Arni.</li>
            <li>Badukhar-Indora-Arni.</li>
        </ul>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/trans1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/trans2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/trans3.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>

        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Medical Facilities – Your Well-Being, Our Responsibility</h2>
        <p>A good health is essential for a thriving fruitful academic journey. ARNI has established a dedicated medical
            facility in the campus area for the well-being of students and faculty members. For the immediate medical
            help, the ARNI’s “Central Medical Clinic” is open 24/7. It has a dedicated medical room along with trained
            staff and doctors.
        </p>
        <p> ARNI has 10-bed “Central Medical Clinic” along with well-trained staff, doctors, and an ambulance.</p>
        <p>The medical facility is filled with essential medical equipment, drugs, and important medicines to avoid delays in any emergency.</p>
        <p>Also, regular check-ups, health drives, and wellness program campaigns take place on a regular basis to promote good health.</p>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/med1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/med2.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>
    </div>
</section>
